import { CalendarIcon } from "components/page-components/Icons/small"
import { Link } from "gatsby"
import React from "react"

export const EventHits = ({ hits, last_entry_ref, close_search_modal }) => {
  return (
    <div className="columns is-multiline">
      {hits?.map(
        (
          { title, objectID, path, event_attendance_mode, event_description },
          i
        ) => (
          <React.Fragment key={objectID}>
            <Link
              to={path}
              onClick={close_search_modal}
              className="column is-6 mb-6"
              ref={
                i === Math.floor((hits.length / 20 - 1) * 20) - 1
                  ? last_entry_ref
                  : null
              }
            >
              <div className="pr-4">
                <p className="has-text-white">
                  {event_attendance_mode}-Veranstaltung
                </p>
                <div className="is-flex my-3">
                  <div
                    className="my-auto mr-4 is-flex"
                    style={{
                      backgroundColor: "white",
                      borderRadius: 8,
                      width: 32,
                      height: 32,
                    }}
                  >
                    <CalendarIcon {...{ className: "m-auto" }} />
                  </div>
                  <p className="has-text-white title is-5 my-auto">{title}</p>
                </div>
                <p
                  className="has-text-white"
                  style={{
                    textOverflow: "ellipsis",
                    WebkitLineClamp: "2",
                    whiteSpace: "nowrap",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                    overflow: "hidden",
                  }}
                >
                  {event_description}
                </p>
              </div>
            </Link>
            <hr className="is-hidden-desktop mx-6" />
          </React.Fragment>
        )
      )}
    </div>
  )
}
